import api from '../../services/api';

export default {
	components: {

	},

	data: function () {
		return {
			loading: false
		};
	},

	created() {},

	/* metodi */
	methods: {},

	/* visualizzazione risultati */
	computed: {}
};